import { AxiosResponse } from 'axios'

import { rawTransform } from 'src/services/skuit/utils'
import { Generic } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export interface ScanResult {
  scanned: Generic
  context: any
}

export class Lookup {
  api: API

  constructor(api: API) {
    this.api = api
  }

  async ident(config: CustomAxiosConfig = {}): Promise<[ScanResult, AxiosResponse]> {
    const response = await this.api.get('/lookup/scan', config)
    response.data.scanned = rawTransform(Generic)(response.data.scanned)
    if (response.data.context) {
      Object.entries(response.data.context).map(
        ([field, data]) => (response.data.context[field] = rawTransform(Generic)(data))
      )
    }
    return [response.data, response]
  }

  async guids(config: CustomAxiosConfig = {}): Promise<Generic> {
    const response = await this.api.get('/lookup/xids', config)
    return rawTransform(Generic)(response.data)
  }
}
